// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"923":"98380978","2840":"a0cf56ad","4061":"92032edf","4084":"98380978","4774":"92032edf","4789":"98380978","7264":"37cf3500","9181":"98380978","9235":"98380978"}[chunkId] + ".chunk.css";
};